<div [formGroup]="form" *ngIf="isVisible">
  <form-field
    class="front mb-0"
    label="New Phone Number *"
    i18n-label="@@support.phoneTicket.newPhone.label"
  >
    <input
      type="text"
      required
      minlength="7"
      maxlength="15"
      formControlName="newPhoneNumber"
      data-testid="support-newPhoneNumber-txtField"
      placeholder="the phone number you want to change to"
      i18n-placeholder="@@support.phoneTicket.newPhone.placeholder"
    />
  </form-field>
  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="newPhoneNumber?.errors?.required && newPhoneNumber?.touched"
    >* This field is required.</small
  >
  <small
    i18n="@@support.phonePatternError"
    class="text-danger"
    *ngIf="newPhoneNumber?.errors?.pattern && newPhoneNumber?.touched"
    >* Please enter a valid phone number.</small
  >

  <div class="row mt-3">
    <div class="col-lg-6">
      <file-uploader
        [maxSize]="1024 * 5"
        [allowedTypes]="['png', 'jpg', 'jpeg']"
        class="w-100"
        data-testid="support-selfie-input"
        (select)="onFileSelect($event, 'personalPhoto')"
        (remove)="onFileRemove('personalPhoto')"
      >
        <input
          #file
          type="file"
          class="input"
          required
          (click)="markAsTouched('personalPhoto')"
        />
        <ng-template #placeholder>
          <img src="assets/images/icons/upload-selfie.svg" alt="upload icon" />
          <div class="text-primary pt-2 text-sm" i18n="@@support.selfie.label">
            Selfie *
          </div>
        </ng-template>
      </file-uploader>
      <small
        i18n="@@support.required"
        class="text-danger"
        *ngIf="personalPhoto?.errors?.required && personalPhoto?.touched"
        >* This field is required.</small
      >
    </div>
    <div class="col-lg-6">
      <file-uploader
        [maxSize]="1024 * 5"
        [allowedTypes]="['png', 'jpg', 'jpeg']"
        data-testid="support-passport-input"
        class="w-100"
        (select)="onFileSelect($event, 'passport')"
        (remove)="onFileRemove('passport')"
      >
        <input
          #file
          type="file"
          class="input"
          required
          (click)="markAsTouched('passport')"
        />
        <ng-template #placeholder>
          <img
            src="assets/images/icons/upload-passport.svg"
            alt="upload icon"
          />
          <div
            class="text-primary pt-2 text-sm"
            i18n="@@support.phoneTicket.passport"
          >
            Passport copy *
          </div>
        </ng-template>
      </file-uploader>
      <small
        i18n="@@support.required"
        class="text-danger"
        *ngIf="passport?.errors?.required && passport?.touched"
        >* This field is required.</small
      >
    </div>
  </div>

  <form-field
    class="front mt-3 textarea"
    label="Ticket Message"
    i18n-label="@@support.message.label"
  >
    <textarea
      formControlName="message"
      data-testid="support-ticketMessage-txtField"
      placeholder="Enter your ticket message"
      rows="5"
      i18n-placeholder="@@support.message.placeholder"
    ></textarea>
  </form-field>
</div>
